module.exports = __webpack_public_path__ + "/images/logo-af-babywalz.06070b4.webp";